import { render, staticRenderFns } from "./ProvinciaArgentina.vue?vue&type=template&id=4f157a82&lang=pug"
import script from "./ProvinciaArgentina.vue?vue&type=script&lang=js"
export * from "./ProvinciaArgentina.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports